import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import { Container } from 'splash/components';

const styles = (theme) => ({
  content: {
    flex: '1 1 auto',
    padding: theme.spacing(1),
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  icon: {
    margin: `${theme.spacing(0)}px auto ${theme.spacing(3)}px auto`,
    width: theme.spacing(7.5),
    height: theme.spacing(7.5),
  },
  svg: {
    width: 'inherit',
    height: 'inherit',
    fill: theme.colors.lightBlue,
  },
  text: {
    color: theme.colors.lightBlue,
  },
});

const ErrorMessage = ({ intl: { messages }, classes }) => (
  <Container>
    <div className={classes.content}>
      <div className={classes.icon}>
        <VisibilityOffIcon className={classes.svg} />
      </div>
      <Typography variant="body1" className={classes.text}>
        {messages.app_disabled}
      </Typography>
    </div>
  </Container>
);

ErrorMessage.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  intl: PropTypes.shape({
    messages: PropTypes.shape({
      app_disabled: PropTypes.string,
    }).isRequired,
  }).isRequired,
};

const WithStylesErrorMessage = withStyles(styles)(ErrorMessage);

export default injectIntl(WithStylesErrorMessage);
